import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import slikaStavbe from '../assets/slika_stavbe_kje_smo.jpeg';

export default function WhereWeAre() {
  const { t } = useLanguage();

  return (
    <div className="where-page">
      <section className="where-page-header">
        <div className="where-page-label">{t.about.location}</div>
        <h1>{t.about.title}</h1>
        <p>{t.about.subtitle}</p>
      </section>

      <section className="where-location">
        <div className="where-location-grid">
          <article className="where-address-card">
            <h2>{t.about.cardTitle}</h2>

            <div className="where-address-detail">
              <div className="where-address-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div className="where-address-info">
                <strong>{t.about.addressTitle}</strong>
                <p>{t.about.addressLine1}<br />{t.about.addressLine2}</p>
                <p className="where-map-link">
                  <a href="https://maps.google.com/?q=Slovenska+cesta+24+1234+Menge%C5%A1" target="_blank" rel="noreferrer">
                    {t.about.mapLinkLabel}
                  </a>
                </p>
              </div>
            </div>

            <div className="where-address-detail">
              <div className="where-address-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div className="where-address-info">
                <strong>{t.about.phoneTitle}</strong>
                <p><a href="tel:040811830">{t.about.officePhone}</a></p>
                <p><a href="tel:+38641606346">{t.about.emergencyPhone}</a></p>
              </div>
            </div>

            <div className="where-address-detail">
              <div className="where-address-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                  <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                  <path d="m22 6-10 7L2 6" />
                </svg>
              </div>
              <div className="where-address-info">
                <strong>{t.about.emailTitle}</strong>
                <p><a href={`mailto:${t.about.email}`}>{t.about.email}</a></p>
              </div>
            </div>

            <div className="where-address-detail">
              <div className="where-address-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <div className="where-address-info">
                <strong>{t.about.hoursTitle}</strong>
                <p>{t.about.hoursText}</p>
              </div>
            </div>
          </article>

          <div className="where-map-wrap">
            <iframe
              title="Slovenska cesta 24, 1234 Mengeš"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2764.5!2d14.5719!3d46.1658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47652dff4a9e3e5d%3A0x0!2sSlovenska%20cesta%2024%2C%201234%20Menge%C5%A1!5e0!3m2!1ssl!2ssi!4v1709300000000"
              className="where-map-iframe"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      <section className="where-directions">
        <div className="where-directions-grid">
          <article className="where-direction-card">
            <div className="where-direction-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <rect x="1" y="3" width="15" height="13" rx="2" />
                <path d="M16 8h4l3 3v5h-7V8z" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
              </svg>
            </div>
            <h3>{t.about.directions[0].title}</h3>
            <p>{t.about.directions[0].text}</p>
          </article>

          <article className="where-direction-card">
            <div className="where-direction-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="m13 2-10 12h9l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <h3>{t.about.directions[1].title}</h3>
            <p>{t.about.directions[1].text}</p>
          </article>

          <article className="where-direction-card">
            <div className="where-direction-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <h3>{t.about.directions[2].title}</h3>
            <p>{t.about.directions[2].text}</p>
          </article>
        </div>
      </section>

      <section className="where-photo">
        <div className="where-photo-frame">
          <img src={slikaStavbe} alt="Stavba odvetniške pisarne BM odvetniki" className="where-photo-image" />
          <div className="where-photo-overlay" />
          <div className="where-photo-text">
            <h3>{t.about.photoTitle}</h3>
            <p>{t.about.photoSubtitle}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
